@for (header of config; track header) {
  <th
    (click)="sortBy(header)"
    [ngClass]="header.sortable ? 'cursor-pointer' : ''">
    <div class="flex align-items-center">
      {{ header.header }}
      @if (header.sortable) {
        <div class="col-2">
          @if (header.sort === 'asc') {
            <i class="pi pi-arrow-up"></i>
          } @else {
            <i class="pi pi-arrow-down"></i>
          }
        </div>
      }
    </div>
  </th>
}
